import { graphql, readInlineData } from 'react-relay';
import get from 'lodash.get';

const RINGS_LABEL = 'rings';
const ITEM_PRICE_THRESHOLD_USD = 20000;

export const viewerFragment = graphql`
    fragment consultAnExpert_viewer on Viewer @inline {
        isConsultAnExpertDisabled: isEnabledByLocale(featureName: "DISABLE_CONSULT_AN_EXPERT")
    }
`;

export const userFragment = graphql`
    fragment consultAnExpert_user on User @inline {
        userRelationships(relationshipType: VIP) {
            userDataB {
                ... on VipRepData {
                    displayName
                }
            }
        }
    }
`;

export const itemFragment = graphql`
    fragment consultAnExpert_item on Item @inline {
        isJewelry
        getCategoriesByLevel(level: 2) {
            label
        }
        pricing {
            totalAmount {
                convertedAmounts {
                    USD
                }
            }
        }
    }
`;

export const shouldShowConsultAnExpert = ({ viewer, item, user, isVip }) => {
    const viewerData = readInlineData(viewerFragment, viewer);
    const itemData = readInlineData(itemFragment, item);
    const isRing =
        get(itemData, 'isJewelry') &&
        get(itemData, 'getCategoriesByLevel[0].label') === RINGS_LABEL;
    const totalAmountInUSD = get(itemData, 'pricing.totalAmount.convertedAmounts.USD');
    const isVipConditionMet = isVip
        ? !get(readInlineData(userFragment, user), 'userRelationships.0.userDataB.0.displayName')
        : true;

    // isVipConditionMet is set to true if the user is not Vip or if the user is vip and has a specified rep
    // userFragment will only be queried if the parent query has isVip variable set to true. Otherwise, it
    // will not be included in the graphql query via the include directive
    return (
        isRing &&
        totalAmountInUSD > ITEM_PRICE_THRESHOLD_USD &&
        !get(viewerData, 'isConsultAnExpertDisabled') &&
        isVipConditionMet
    );
};

export const shouldLaunchConsultAnExpert = () => {
    if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        const consultAnExpertParam = urlParams.get('consultAnExpert') || '';

        return consultAnExpertParam.toLowerCase() === 'true';
    }

    return false;
};
